import styled, { css } from 'styled-components';

type TStatus = {
  statusText?: string;
  small?: boolean;
  alternative?: boolean;
};

type TStatusWrapper = {
  statusName: string;
  small?: boolean;
  alternative?: boolean;
};

const StatusWrapper = styled.span<TStatusWrapper>(
  ({ theme, statusName, small, alternative }) => css`
    color: ${theme.colors.appStatuses[statusName].text};
    background-color: ${theme.colors.appStatuses[statusName].background};
    border: 2px solid ${theme.colors.appStatuses[statusName].background};
    transition:
      background-color 0.35s ease,
      opacity 0.35s ease;
    padding: 0.125rem 0.5rem;
    border-radius: ${theme.borderRadii.status};
    word-break: normal;

    ${small &&
    css`
      font-size: ${theme.fonts.sizes.h6};
    `}

    ${alternative &&
    css`
      background-color: transparent;
    `}
  `
);

const AppStatus = ({ statusText, small, alternative }: TStatus) => {
  let statusName = null;

  switch (statusText) {
    case 'NEW - Entered':
      statusName = 'new';
      break;
    case 'Pending Approval':
      statusName = 'pending';
      break;
    case 'Approved - Not signed':
      statusName = 'pending';
      break;
    case 'Approved':
      statusName = 'approved';
      break;
    case 'Rejected':
      statusName = 'rejected';
      break;
    case 'Cancelled':
      statusName = 'cancelled';
      break;
    case 'Signed':
      statusName = 'signed';
      break;
    case 'Signed - Pending Zepto agreement':
      statusName = 'signed';
      break;
    case 'Payment Assist - Refer':
      statusName = 'converted';
      break;
    case 'EP - Pending Approval':
      statusName = 'converted';
      break;
    case 'Pending ID':
      statusName = 'pending';
  }

  return (
    <>
      {statusName !== null && (
        <StatusWrapper
          className="status-wrapper"
          statusName={statusName}
          small={small}
          alternative={alternative}
        >
          {statusText}
        </StatusWrapper>
      )}
    </>
  );
};

const getStatusText = (status?: string, subStatus?: string): string => {
  if (!status) {
    return 'UNKNOWN_STATUS';
  }
  if (status === 'UNKNOWN_STATUS' && subStatus) {
    return subStatus;
  }
  if (status === 'Pending Approval' && subStatus === 'PA_REFER') {
    return 'EP - Pending Approval';
  }
  return status;
};

export { AppStatus, StatusWrapper, getStatusText };
